import React from 'react';
import PropTypes from 'prop-types';

import Tax from '../component/tax';
import Product from './product';
import TotalAmount from '../component/totalAmount';
import ShippingDetails from '../component/shippingDetails';
import SecurityDeposit from '../component/securityDeposit';
import { getProductRefData } from '../../../../../utils/plansReference';
import '../../mobileCart.css';
import { Margin } from '../../../styles';
import { isWHWP2 } from '../../../Helpers';

const DueToday = ({ cartDetails, plansReferenceData }) => {
  const { dueTodayList = {}, dueTodayTaxes = {}, orderDetailsView = {}, shippingDetails = {} } = cartDetails || {};
  const whwDueTodayList = isWHWP2() && cartDetails ? cartDetails.dueMonthlyList.concat(dueTodayList) : {};

  const securityDepositVal = orderDetailsView?.fwaSecurityDepositAmount ?? '';

  const plansReference = plansReferenceData || {};
  const { dueatshipment } = plansReference?.miniCart ?? {};

  const planInfo = getProductRefData('dueTodayTax', 'dueTodayTax', plansReference);

  return (
    <Margin top="14px">
      {orderDetailsView && (
        <TotalAmount
          showDueToday
          totalDueTodayAmount={orderDetailsView?.dueTodayAmount}
          dueatshipment={dueatshipment}
          taxText={!isWHWP2() && dueTodayTaxes?.[0]?.dueAmount === '0.0' ? planInfo?.[0]?.taxValue : ''}
        />
      )}
      {dueTodayList && <Product showDueToday dueTodayList={dueTodayList} whwDueTodayList={whwDueTodayList} plansReferenceData={plansReferenceData} />}
      {securityDepositVal && <SecurityDeposit securityDepositAmt={securityDepositVal} />}
      {shippingDetails && <ShippingDetails shippingDetails={shippingDetails} />}
      {dueTodayList && dueTodayTaxes && dueTodayTaxes.length > 0 && (
        <Tax
          showDueToday={dueTodayTaxes?.[0]?.dueAmount !== '0.0'}
          totalDueTodayTaxAmount={dueTodayTaxes?.[0]?.dueAmount}
          taxText={dueTodayTaxes?.[0]?.dueAmount !== '0.0' ? planInfo?.[0]?.taxText ?? '' : ''}
        />
      )}
    </Margin>
  );
};

DueToday.propTypes = {
  cartDetails: PropTypes.object,
  plansReferenceData: PropTypes.object,
};

export default DueToday;
